import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function WelcomeCard(props) {
  // Get user name from Redux
  const { user } = useSelector((state) => state.auth);
  const userName = user?.user_name?.split("@")[0] || "User"; // Extract name from email

  // Destructure props with defaults
  const {
    message = "Your account is ready to go. While we prepare for the new season, explore what’s ahead and stay connected.",
    primaryCta = {
      text: "Visit our blog",
      link: "/blog",
      type: "link",
    },
    secondaryCta = null,
  } = props;

  return (
    <div className="filing-hub">
      {/* Left Column */}
      <div className="filing-hub-left">
        <h2 className="filing-hub-title">Hey {userName}</h2>
        <p className="section-description-white">
          All your taxes, guidance, and support — in one place.
        </p>
      </div>

      {/* Right Column */}
      <div className="filing-hub-right">
        <div className="whats-next-section">
          <h3 className="whats-next-title">What's next</h3>
          <p className="whats-next-description">{message}</p>
        </div>

        <div className="cta-buttons">
          {primaryCta.type === "link" ? (
            <Link to={primaryCta.link} className="cta-button primary">
              {primaryCta.text}
            </Link>
          ) : (
            <button className="cta-button primary" onClick={primaryCta.onClick}>
              {primaryCta.text}
            </button>
          )}

          {secondaryCta &&
            (secondaryCta.type === "link" ? (
              <Link to={secondaryCta.link} className="cta-button secondary">
                {secondaryCta.text}
              </Link>
            ) : (
              <button
                className="cta-button secondary"
                onClick={secondaryCta.onClick}
              >
                {secondaryCta.text}
              </button>
            ))}
        </div>
      </div>
    </div>
  );
}

export default WelcomeCard;
